import { React, useEffect, useState } from 'react';
import ProfileCard from '@molecules/pursuitLeader/components/dashboard/profileCard';
import DataCardOne from '@molecules/pursuitLeader/components/dashboard/dataCardOne';
import DataCardTwo from '@molecules/pursuitLeader/components/dashboard/dataCardTwo';
import { PersonalContainer } from '@atoms/dashboard/personalDashboard.styles';
import { useRecoilValue } from 'recoil';
import {
  Current_User,
  Recoil_Quarter_State,
  System_Date_Time_State,
  Recoil_Selected_Account_State,
} from '@recoil/recoil';
import { getMyDashboardData } from '@services/pursuitLeaderServices';
import { getDashboardProfileDetails, getDashboardAllQuartersData } from '@services/commonServices';
import { appInsights } from '@services/appInsightsService';
import { SOURCE } from '@constants/commonConstants';

const PersonalDashboard = () => {
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const currentUser = useRecoilValue(Current_User);
  const systemDateTime = useRecoilValue(System_Date_Time_State);
  const selectedUser = useRecoilValue(Recoil_Selected_Account_State);

  const [desktopData, setDesktopData] = useState(null);
  const [profileData, setProfileData] = useState(null);
  const [forecastAccuracy, setForecastAccuracy] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (quarterInfo !== null && selectedUser !== null) {
        const currentYear = quarterInfo.fiscal_year;

        try {
          // Fetch desktop data
          const myDesktopData = await getMyDashboardData(
            currentYear,
            currentUser.email,
            systemDateTime.split('T')[0],
          );
          setDesktopData(myDesktopData);

          // Fetch profile data
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Calling getDashboardProfileDetails using ${currentUser.email}`,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 1, // 1 represents response log
          });
          const myProfileData = await getDashboardProfileDetails(currentUser.email);
          setProfileData(myProfileData);

          // Fetch forecast accuracy data
          appInsights.trackTrace({
            message: JSON.stringify({
              message: `Calling getDashboardAllQuartersData using ${currentUser.email}, ${currentYear}, ${systemDateTime.split('T')[0]}, ${selectedUser.role}, ${currentUser.account_id}`,
              userId: localStorage.getItem('userEmail'),
              source: SOURCE.FRONTEND,
            }),
            severityLevel: 1, // 1 represents response log
          });
          const dashboardAllQuarterData = await getDashboardAllQuartersData(
            currentUser.email,
            currentYear,
            systemDateTime.split('T')[0],
            // ROLE_CONST.PL,
            selectedUser.role,
            currentUser.account_id,
          );
          setForecastAccuracy(dashboardAllQuarterData);
        } catch (error) {
          console.error('Error fetching data:', error);
        }
      }
    };

    fetchData();
  }, [quarterInfo, selectedUser]);

  return (
    <>
      {quarterInfo !== null &&
      desktopData !== null &&
      profileData !== null &&
      forecastAccuracy !== null ? (
        <PersonalContainer>
          <ProfileCard data={profileData} />
          <DataCardOne data={forecastAccuracy.forecast_accuracy} />
          <DataCardTwo data={desktopData.forecast_completion} />
        </PersonalContainer>
      ) : null}
    </>
  );
};

export default PersonalDashboard;
